import { render } from "./organisation.vue?vue&type=template&id=f9fa8066&ts=true"
import script from "./organisation.ts?vue&type=script&lang=ts&external"
export * from "./organisation.ts?vue&type=script&lang=ts&external"

import "./organisation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__